import { Adapter as m } from "../../../../../adapter.js";
import { StampProgrammeSettingsBalanceModel as a } from "./stampProgrammeSettingsBalance.model.js";
class l extends m {
  adapt(e) {
    return new a({
      cycle: {
        infinite: e.cycle.infinite,
        maximumIterations: e.cycle.maximum_iterations
      },
      initialBalance: e.initial_balance,
      maximumAccumulatedBalance: e.maximum_accumulated_balance,
      maximumBalance: e.maximum_balance
    });
  }
  serialize(e) {
    throw new Error("Method not implemented.");
  }
}
export {
  l as StampProgrammeBalanceAdapter
};
//# sourceMappingURL=stampProgrammeSettingsBalance.adapter.js.map
